/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import { useForm } from "@/src/provider/Form/FormProvider";
import CheckIcon from "@/src/assets/icons/common/toggleable/IconCheck";
import CrossIcon from "@/src/assets/icons/common/toggleable/IconClose";
import { isRequired } from "@/src/services/validationRules";
import Group from "@/src/components/Wizard/Group";
import Typography from "@mui/material/Typography";
import { translate } from "@/src/services/translations/translations";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type ProcessCostSupportProps = {
  submitProps: FormSubmitProps;
};
export default function ProcessCostSupport({ submitProps }: ProcessCostSupportProps) {
  const { handleSubmit, values } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Finanzen
          </Typography>
          <Typography variant={"h4"} sx={wizardStyle.subheadline}>
            {translate("divorce.hasProcessCostSupport.label", values)}
          </Typography>
          <Group
            type="radio"
            name="hasProcessCostSupport"
            question={translate("divorce.hasProcessCostSupport.question", values)}
            modalContent={
              <>
                <p>
                  Bei geringem Einkommen oder hohen Schulden können Sie Verfahrenskostenhilfe (Prozesskostenhilfe) beantragen. Wird diese bewilligt, müssen Sie
                  für die Scheidung nichts zahlen. Ob der Staat die Kosten übernimmt, hängt davon ab, wie viel Geld Sie monatlich zur Verfügung haben. Wenn Sie
                  Sozialhilfe oder Bürgergeld (ehemals ALG2 bzw. umgangssprachlich „Hartz 4“) erhalten, wird die Verfahrenskostenhilfe in der Regel immer
                  übernommen und das Scheidungsverfahren wäre dann für Sie kostenlos.
                </p>
                <p>Zur Beantragung der Verfahrenskostenhilfe erhalten Sie im Anschluss eine E-Mail mit allen weiteren Informationen.</p>
              </>
            }
            options={[
              {
                labelText: translate("divorce.hasProcessCostSupport.options.yes.label", values),
                labelIcon: <CheckIcon />,
                labelIconActive: <CheckIcon active />,
                value: "yes",
                optionHintText: "Mit Hilfe unseres Verfahrenskostenhilfe-Assistenten können Sie im Nachgang den Antrag komplett digital erstellen.",
              },
              {
                labelText: translate("divorce.hasProcessCostSupport.options.no.label", values),
                labelIcon: <CrossIcon />,
                labelIconActive: <CrossIcon active />,
                value: "no",
                optionHintText: "Gerne besprechen wir mit Ihnen auch andere Finanzierungsmöglichkeiten, wie zum Beispiel eine Ratenzahlung.",
              },
            ]}
            validators={[
              {
                validator: isRequired,
                message: "Bitte geben Sie an ob Sie Verfahrenkostenhilfe beantragen möchten",
              },
            ]}
          />
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
